import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  detailsContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    width: "100%",
    maxWidth: "25rem",
    margin: "0 auto",
  },
  circularProgress: {
    display: "block",
    margin: "2rem auto",
  },
  qrcode: {
    background: "white",
    padding: "1rem",
    borderRadius: "0.5rem",
    boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
    marginBottom: "1rem",
    [theme.breakpoints.down("sm")]: {
      padding: "0.75rem",
      marginBottom: "0.75rem",
    },
  },
  valetAreaRow: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
    width: "100%",
    marginBottom: "0.5rem",
  },
  valetAreaValue: {
    fontSize: "1.5rem",
    fontWeight: "bold",
    color: theme.palette.primary.main,
    [theme.breakpoints.down("sm")]: {
      fontSize: "1.25rem",
    },
  },
  fieldRow: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
    width: "100%",
    padding: "0.5rem 0",
    borderBottom: "1px solid #e0e0e0",
  },
  fieldLabel: {
    fontSize: "0.875rem",
    fontWeight: "bold",
    color: theme.palette.primary.main,
    marginBottom: "0.25rem",
    textTransform: "uppercase",
    letterSpacing: "0.025rem",
  },
  fieldValue: {
    fontSize: "1.125rem",
    fontWeight: "normal",
    color: theme.palette.primary.main,
    lineHeight: "1.4",
    [theme.breakpoints.down("sm")]: {
      fontSize: "1rem",
    },
  },
  buttonContainer: {
    width: "100%",
    marginTop: "1.5rem",
  },
  requestButton: {
    padding: "0.75rem 1rem",
    fontSize: "1.125rem",
    fontWeight: "bold",
    textTransform: "none",
  },
  confirmationMessage: {
    textAlign: "center",
    fontSize: "1.125rem",
    fontWeight: "bold",
    color: theme.palette.success?.main ?? theme.palette.primary.main,
    padding: "0.75rem 0",
  },
}));
